import { useState } from "react";
import { Report } from "../../__generated__/graphql";
import { notify } from "../../utils/toast";
import { HiMail } from "react-icons/hi";

export const ReportModal = ({
  report,
  onClose,
}: {
  report: Report;
  onClose: () => void;
}) => {
  const [inputValue, setInputValue] = useState("");
  const [showThankYouModal, setShowThankYouModal] = useState(false);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (inputValue !== "네 동참할게요") {
      notify("다시 입력해주세요!");
      return;
    }

    setShowThankYouModal(true);
  };

  const handleThankYouConfirm = () => {
    onClose();
  };

  // 두번째 모달
  if (showThankYouModal) {
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
        <div className="bg-white rounded-xl max-w-md w-full p-6">
          <div className="text-center">
            <div className="flex justify-center mb-4">
              <HiMail className="w-6 h-6 text-gray-800" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              확인해주셔서 감사합니다.
            </h2>
            <div>
              <p className="text-gray-700 font-medium leading-relaxed break-keep">
                혹시 개선·요청사항이 있다면
              </p>
              <p className="text-gray-700 font-medium mb-6 leading-relaxed break-keep">
                <a
                  href="http://pf.kakao.com/_xawxcRn/chat"
                  className="underline underline-offset-2 text-blue-500 font-semibold rounded-lg active:text-blue-600 transition duration-300"
                >
                  마감히어로 카카오채널
                </a>
                로 연락 부탁드려요!
              </p>
            </div>
            <button
              onClick={handleThankYouConfirm}
              className="w-full px-4 py-3 bg-blue-500 text-white rounded-lg active:bg-blue-600 font-medium"
            >
              확인
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
      <div className="bg-white rounded-xl max-w-lg w-full p-6 overflow-y-auto max-h-[90vh]">
        <div className="flex justify-center mb-3">
          <HiMail className="w-6 h-6 text-gray-800" />
        </div>
        <div className="mb-6">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center">
            마감히어로에서 편지가 도착했어요
          </h2>
          <div className="mb-6">
            <div>
              <p className="font-medium text-gray-900 mt-2 pl-2 border-l-2 border-blue-200 leading-relaxed italic font-semibold">
                {report.result}
              </p>
            </div>
          </div>
        </div>

        <div className="mb-6 space-y-3 border-t border-gray-200 pt-6">
          <p className="text-gray-700 font-medium leading-relaxed text-xl">
            마감히어로와 사장님과 고객님의 아름다운 공생에 동참해주세요!
          </p>
          <p className="mt-3 text-gray-700 font-medium">
            아래 문구를 입력해주시면 다음으로 넘어갈게요.
          </p>
          <p className="text-center font-bold bg-gray-100 p-2 text-xl">
            네 동참할게요
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            placeholder="문구를 입력해주세요"
            className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 font-medium"
          />

          <button
            type="submit"
            className="w-full px-4 py-3 bg-blue-500 text-white rounded-lg active:bg-blue-600 font-medium mt-6"
          >
            확인
          </button>
        </form>
      </div>
    </div>
  );
};
